<template>
  <div class="MR_meteorologicalData" ref="MR_meteorologicalData" @click="rowClick()">
    <div class="monitorPointsBg"></div>
    <ul>
      <li v-for="(item,i) in dataList" :key="i">
        <div class="li_count number">
          {{item.value }}
        </div>
        <div class="li_name">
          {{ item.signalName }}{{item.unit}}
        </div>
      </li>
    </ul>
    <div class="tips">{{tip}}</div>
  </div>
</template>



<script>
import { mapGetters } from "vuex";
export default {
  props: ["matrix", "x", "y"],
  components: {
    // lowCarbonPopup2,
  },
  data() {
    return {
      pageInfo: 'MR_meteorologicalData.vue',
      computedName: '气象数据组件',
      customerId: this.$store.state.customerId,
      dataList: [],
      setTime1: null,
      tip: "",
    };
  },
  computed: {},

  watch: {},

  created() {},

  mounted() {
    let that = this;
    let w = $(that.$refs.MR_meteorologicalData).outerWidth();
    let h = $(that.$refs.MR_meteorologicalData).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.getListData();
  },
  unmounted() {
    if (this.setTime1) {
      clearTimeout(this.setTime1);
      this.setTime1 = null;
    }
  },
  methods: {
    async getListData() {
      if (this.setTime1) {
        clearTimeout(this.setTime1);
        this.setTime1 = null;
      }
      try {
        const getWeatherStation =
          CONFIG.requestName + this.$apiOpt.getWeatherStation;
        let res = await this.$apiUtils.get(getWeatherStation, {
          customerId: this.customerId,
        });
        let arr = [
          { categoryId: 8, signalName: "温度", value: "-", unit: "℃" },
          { categoryId: 22, signalName: "湿度", value: "-", unit: "%" },
          { categoryId: 65, signalName: "风速", value: "-", unit: "m/s" },
          { categoryId: 600, signalName: "降雨量", value: "-", unit: "mm" },
        ];
        res.list.forEach((item) => {
          arr.forEach((item_) => {
            if (item.categoryId == item_.categoryId) {
              item_.value = item.value;
            }
          });
        });
        this.dataList = arr;
        this.tip = res.tip;
      } catch (err) {
        console.log(err);
      }
      this.setTime1 = setTimeout(() => {
        this.getListData();
      }, 60 * 1000 * 5);
    },
  },
};
</script>



<style lang="scss" scoped="scoped">
.MR_meteorologicalData {
  height: 250px;
  width: 600px;
  .monitorPointsBg {
    @include bg-box(560px, 178px, "wrapbg.png");
    margin-top: 32px;
    position: absolute;
    z-index: -1;
  }
  ul {
    margin-top: 32px;
    height: 128px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    @include bg-box(560px, 180px, "ulBg.png");
    padding: 0 10px;
    li {
      width: 25%;
      .li_count {
        height: 30px;
        font-size: 25px;
        font-weight: 400;
        color: rgb(244, 196, 143);
        line-height: 30px;
        margin-bottom: 5px;
        margin-top: 70px;
        text-align: end;
        margin-right: 16px;
      }
      .li_name {
        font-size: 18px;
        font-weight: 400;
        color: rgb(132, 137, 149);
        line-height: 30px;
        text-align: center;
      }
    }
  }
  .tips {
    height: 22px;
    line-height: 22px;
    color: #89dce9;
    position: absolute;
    bottom: 23px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 18px;
  }
}
</style>
